export default __webpack_public_path__ + "static/traction_map-e4813e59db95c5de216c8d09bf53490e.png";